import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CountryRestrictionDialogData {
    countryName: string;
    countryCode: string;
}

@Component({
    selector: 'app-country-restriction-dialog',
    templateUrl: './country-restriction-dialog.component.html',
    styleUrls: ['./country-restriction-dialog.component.scss']
})
export class CountryRestrictionDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<CountryRestrictionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CountryRestrictionDialogData
    ) { }

    onRequestQuotation(): void {
        this.dialogRef.close('request_quote');
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
